var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "satisfaction-metrics" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "overall-satisfaction" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "satisfaction-score-card" }, [
              _c(
                "div",
                {
                  staticClass: "score-circle",
                  class: _vm.getScoreClass(_vm.satisfaccionMetrics.general),
                },
                [
                  _c("div", { staticClass: "score-value" }, [
                    _vm._v(_vm._s(_vm.satisfaccionMetrics.general || 0)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "score-label" }, [
                    _vm._v("Puntuación General"),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "satisfaction-trends" },
              [
                _c("h6", [_vm._v("Tendencias de Satisfacción")]),
                _vm._v(" "),
                _vm._l(
                  _vm.satisfaccionMetrics.tendencias,
                  function (valor, periodo) {
                    return _c(
                      "div",
                      { key: periodo, staticClass: "trend-item" },
                      [
                        _c("div", { staticClass: "trend-period" }, [
                          _vm._v(_vm._s(_vm.getPeriodLabel(periodo))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "trend-value" }, [
                          _vm._v(_vm._s(valor)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "trend-bar" }, [
                          _c("div", {
                            staticClass: "trend-progress",
                            style: { width: (valor / 5) * 100 + "%" },
                          }),
                        ]),
                      ]
                    )
                  }
                ),
              ],
              2
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "agent-satisfaction" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "agent-satisfaction-grid" },
          _vm._l(
            _vm.satisfaccionMetrics.por_agente,
            function (puntuacion, agente) {
              return _c(
                "div",
                { key: agente, staticClass: "agent-satisfaction-item" },
                [
                  _vm._m(2, true),
                  _vm._v(" "),
                  _c("div", { staticClass: "agent-info" }, [
                    _c("div", { staticClass: "agent-name" }, [
                      _vm._v(_vm._s(agente)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "agent-score",
                        class: _vm.getScoreClass(puntuacion),
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(puntuacion) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "agent-trend" }, [
                    _c(
                      "div",
                      {
                        staticClass: "trend-indicator",
                        class: _vm.getTrendClass(puntuacion),
                      },
                      [_c("i", { class: _vm.getTrendIcon(puntuacion) })]
                    ),
                  ]),
                ]
              )
            }
          ),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "type-satisfaction" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "type-satisfaction-chart" },
          _vm._l(_vm.satisfaccionMetrics.por_tipo, function (puntuacion, tipo) {
            return _c("div", { key: tipo, staticClass: "type-item" }, [
              _c("div", { staticClass: "type-header" }, [
                _c("div", { staticClass: "type-name" }, [_vm._v(_vm._s(tipo))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "type-score",
                    class: _vm.getScoreClass(puntuacion),
                  },
                  [
                    _vm._v(
                      "\n              " + _vm._s(puntuacion) + "\n            "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "type-bar" }, [
                _c("div", {
                  staticClass: "type-progress",
                  class: _vm.getScoreClass(puntuacion),
                  style: { width: (puntuacion / 5) * 100 + "%" },
                }),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "correlation-analysis" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "correlation-card" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "correlation-content" }, [
                _c("div", { staticClass: "correlation-value" }, [
                  _vm._v(
                    _vm._s(
                      (
                        _vm.satisfaccionMetrics.correlacion_tiempo * 100
                      ).toFixed(0)
                    ) + "%"
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "correlation-label" }, [
                  _vm._v("Correlación con Tiempo de Resolución"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "correlation-description" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getCorrelationDescription(
                          _vm.satisfaccionMetrics.correlacion_tiempo
                        )
                      ) +
                      "\n              "
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "feedback-summary" }, [
              _c("h6", [_vm._v("Resumen de Feedback")]),
              _vm._v(" "),
              _c("div", { staticClass: "feedback-stats" }, [
                _c("div", { staticClass: "feedback-stat positive" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-value" }, [
                      _vm._v(
                        _vm._s(_vm.satisfaccionMetrics.feedback_positivo) + "%"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("Feedback Positivo"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "feedback-stat negative" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-value" }, [
                      _vm._v(
                        _vm._s(_vm.satisfaccionMetrics.feedback_negativo) + "%"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("Feedback Negativo"),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-smile text-warning" }),
      _vm._v(" Métricas de Satisfacción del Usuario"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-users text-primary" }),
      _vm._v(" Satisfacción por Agente"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "agent-avatar" }, [
      _c("i", { staticClass: "fal fa-user" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-tags text-success" }),
      _vm._v(" Satisfacción por Tipo de Solicitud"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "correlation-icon text-info" }, [
      _c("i", { staticClass: "fal fa-chart-line" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "fal fa-thumbs-up" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "fal fa-thumbs-down" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }